<template>
  <div class="content">
    <div class="md-layout md-alignment-center">
      <div
        v-if="abn === ''"
        class="md-layout-item md-layout-item md-xlarge-size-50 md-large-size-50 md-small-size-100 md-xsmall-size-100"
      >
        <business-lookup-card @reg="handleReg" />
      </div>
      <div
        v-else
        class="md-layout-item md-layout-item md-xlarge-size-75 md-large-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <edit-business-form
          :create-mode="true"
          :lookup-data="{ abn, lookupName }"
          data-background-color="secondary"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EditBusinessForm from "@/views/Forms/EditBusinessForm";
import BusinessLookupCard from "@/components/Cards/BusinessLookupCard";

export default {
  components: {
    BusinessLookupCard,
    EditBusinessForm
  },
  data() {
    return {
      abn: "",
      lookupName: ""
    };
  },
  methods: {
    handleReg(givenAbn, lookupName) {
      this.abn = givenAbn;
      this.lookupName = lookupName;
    }
  }
};
</script>

<style scoped></style>
